import { Alert, Box, Stack } from '@mui/material'

import { type DeliverySourceType, type EmailStats } from '../types'
import { formatNumber } from '../utils'
import DailyEmailsChart from './DailyEmailsChart'
import KpiCard from './KpiCard'

type DashboardProps = {
  error?: unknown
  loading: boolean
  stats: EmailStats
  onSelectSends: (sourceType?: DeliverySourceType) => void
}

const Dashboard = ({
  error,
  loading,
  stats,
  onSelectSends
}: DashboardProps) => (
  <Stack gap={3}>
    <>
      {error && (
        <Alert severity="error" sx={{ borderRadius: '16px' }}>
          Impossible de charger les statistiques des emails.
        </Alert>
      )}

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' },
          gap: 2
        }}
      >
        <KpiCard
          title="Campagnes"
          value={loading ? '-' : formatNumber(stats.campaignsSentCount)}
          subtitle="mails envoyés"
          icon="fa-light fa-paper-plane"
          iconColor="#2570EB"
          ariaLabel="Afficher les envois des campagnes"
          onClick={() => onSelectSends('campaign')}
        />
        <KpiCard
          title="Déclencheurs"
          value={loading ? '-' : formatNumber(stats.triggersSentCount)}
          subtitle="mails envoyés"
          icon="fa-light fa-bolt"
          iconColor="#F59E0B"
          ariaLabel="Afficher les envois des déclencheurs"
          onClick={() => onSelectSends('trigger')}
        />
        <KpiCard
          title="Total campagnes + déclencheurs"
          value={loading ? '-' : formatNumber(stats.totalSentCount)}
          subtitle={`${loading ? '-' : formatNumber(Math.round(stats.averageSentPerDay))} mails envoyés / jour en moyenne`}
          icon="fa-light fa-envelope"
          iconColor="#3D3D3D"
          ariaLabel="Afficher la liste de tous les envois"
          onClick={() => onSelectSends()}
        />
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', lg: 'repeat(2, minmax(0, 1fr))' },
          gap: 2
        }}
      >
        <DailyEmailsChart
          title="Campagnes par jour"
          data={stats.campaignsDailyCounts}
          color="#2570EB"
          loading={loading}
        />
        <DailyEmailsChart
          title="Déclencheurs par jour"
          data={stats.triggersDailyCounts}
          color="#F59E0B"
          loading={loading}
        />
      </Box>
    </>
  </Stack>
)

export default Dashboard
